import React from "react";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-12 sm:py-16 md:py-20 bg-white relative overflow-hidden"
    >
      {/* Primary Background Pattern - Organic Flowing Shapes */}
      <div className="absolute inset-0">
        <svg
          className="w-full h-full"
          viewBox="0 0 1200 800"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Large organic shapes */}
          <path
            d="M-100,200 Q200,100 400,200 T700,200 Q900,300 1100,200 L1100,800 L-100,800 Z"
            fill="url(#gradient1)"
            opacity="0.08"
          />
          <path
            d="M-100,600 Q300,500 500,600 T800,600 Q1000,700 1200,600 L1200,800 L-100,800 Z"
            fill="url(#gradient2)"
            opacity="0.06"
          />

          {/* Floating geometric elements */}
          <circle
            cx="150"
            cy="150"
            r="40"
            fill="url(#gradient3)"
            opacity="0.1"
          />
          <circle
            cx="1050"
            cy="120"
            r="25"
            fill="url(#gradient4)"
            opacity="0.08"
          />
          <circle
            cx="200"
            cy="650"
            r="30"
            fill="url(#gradient5)"
            opacity="0.09"
          />
          <circle
            cx="1000"
            cy="700"
            r="35"
            fill="url(#gradient6)"
            opacity="0.07"
          />

          {/* Subtle connecting lines */}
          <path
            d="M150,150 Q600,100 1050,120"
            stroke="rgb(47, 78, 59)"
            strokeWidth="0.5"
            opacity="0.03"
          />
          <path
            d="M200,650 Q600,680 1000,700"
            stroke="rgb(47, 78, 59)"
            strokeWidth="0.5"
            opacity="0.03"
          />

          {/* Mandala-inspired patterns */}
          <g opacity="0.04">
            <circle
              cx="300"
              cy="300"
              r="80"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
            <circle
              cx="300"
              cy="300"
              r="60"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
            <circle
              cx="300"
              cy="300"
              r="40"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
            <circle
              cx="300"
              cy="300"
              r="20"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
          </g>

          <g opacity="0.04">
            <circle
              cx="900"
              cy="500"
              r="70"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
            <circle
              cx="900"
              cy="500"
              r="50"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
            <circle
              cx="900"
              cy="500"
              r="30"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
            <circle
              cx="900"
              cy="500"
              r="10"
              stroke="rgb(47, 78, 59)"
              strokeWidth="1"
              fill="none"
            />
          </g>

          {/* Gradients */}
          <defs>
            <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgb(227, 233, 226)" />
              <stop offset="100%" stopColor="rgb(240, 248, 255)" />
            </linearGradient>
            <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgb(240, 248, 255)" />
              <stop offset="100%" stopColor="rgb(227, 233, 226)" />
            </linearGradient>
            <radialGradient id="gradient3" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgb(0, 49, 83)" />
              <stop offset="100%" stopColor="rgb(47, 78, 59)" />
            </radialGradient>
            <radialGradient id="gradient4" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgb(192, 161, 107)" />
              <stop offset="100%" stopColor="rgb(47, 78, 59)" />
            </radialGradient>
            <radialGradient id="gradient5" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgb(227, 233, 226)" />
              <stop offset="100%" stopColor="rgb(0, 49, 83)" />
            </radialGradient>
            <radialGradient id="gradient6" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgb(47, 78, 59)" />
              <stop offset="100%" stopColor="rgb(192, 161, 107)" />
            </radialGradient>
          </defs>
        </svg>
      </div>

      {/* Pattern Layer 2 - Geometric Grid */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg stroke='%23474e3b' stroke-opacity='0.1'%3E%3Cpath d='M30,0 L30,60 M0,30 L60,30'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      {/* Pattern Layer 3 - Wave Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <svg
          className="w-full h-full"
          viewBox="0 0 1200 800"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,400 Q150,350 300,400 T600,400 Q750,450 900,400 T1200,400"
            stroke="rgb(47, 78, 59)"
            strokeWidth="0.5"
            fill="none"
            opacity="0.08"
          />
          <path
            d="M0,500 Q150,450 300,500 T600,500 Q750,550 900,500 T1200,500"
            stroke="rgb(47, 78, 59)"
            strokeWidth="0.5"
            fill="none"
            opacity="0.06"
          />
          <path
            d="M0,300 Q150,250 300,300 T600,300 Q750,350 900,300 T1200,300"
            stroke="rgb(47, 78, 59)"
            strokeWidth="0.5"
            fill="none"
            opacity="0.04"
          />
        </svg>
      </div>

      {/* Pattern Layer 4 - Dot Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23474e3b' fill-opacity='0.1'%3E%3Ccircle cx='20' cy='20' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "40px 40px",
          }}
        ></div>
      </div>

      {/* Pattern Layer 5 - Hexagonal Pattern */}
      <div className="absolute inset-0 opacity-[0.01]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg stroke='%23474e3b' stroke-opacity='0.08'%3E%3Cpath d='M40,10 L70,25 L70,55 L40,70 L10,55 L10,25 Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "80px 80px",
          }}
        ></div>
      </div>

      {/* Pattern Layer 6 - Triangle Pattern */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg stroke='%23474e3b' stroke-opacity='0.06'%3E%3Cpath d='M25,5 L45,40 L5,40 Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "50px 50px",
          }}
        ></div>
      </div>

      {/* Pattern Layer 7 - Diamond Pattern */}
      <div className="absolute inset-0 opacity-[0.01]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='70' height='70' viewBox='0 0 70 70' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg stroke='%23474e3b' stroke-opacity='0.05'%3E%3Cpath d='M35,10 L60,35 L35,60 L10,35 Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "70px 70px",
          }}
        ></div>
      </div>

      {/* Animated Floating Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Particle System */}
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-forest-green/20 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
            }}
          />
        ))}

        {/* Larger floating elements with different animations */}
        <div
          className="absolute top-1/4 left-1/6 w-3 h-3 bg-gradient-to-br from-soft-saffron/30 to-copper-brown/30 rounded-full animate-float"
          style={{ animationDelay: "0s" }}
        ></div>
        <div
          className="absolute top-1/3 right-1/5 w-2 h-2 bg-gradient-to-br from-earth-ochre/25 to-misty-sage/25 rounded-full animate-float"
          style={{ animationDelay: "1.5s" }}
        ></div>
        <div
          className="absolute bottom-1/3 left-1/4 w-4 h-4 bg-gradient-to-br from-misty-sage/20 to-sand-beige/20 rounded-full animate-float"
          style={{ animationDelay: "2.5s" }}
        ></div>
        <div
          className="absolute bottom-1/4 right-1/3 w-2.5 h-2.5 bg-gradient-to-br from-copper-brown/20 to-soft-saffron/20 rounded-full animate-float"
          style={{ animationDelay: "1s" }}
        ></div>
      </div>

      {/* Pattern Layer 8 - Additional Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Small decorative circles */}
        <div className="absolute top-1/6 left-1/8 w-2 h-2 bg-forest-green/15 rounded-full"></div>
        <div className="absolute top-1/5 right-1/6 w-1.5 h-1.5 bg-copper-brown/12 rounded-full"></div>
        <div className="absolute bottom-1/6 left-1/5 w-1 h-1 bg-soft-saffron/10 rounded-full"></div>
        <div className="absolute bottom-1/5 right-1/8 w-2.5 h-2.5 bg-earth-ochre/8 rounded-full"></div>

        {/* Subtle lines */}
        <div className="absolute top-1/3 left-1/12 w-16 h-px bg-gradient-to-r from-transparent via-forest-green/10 to-transparent"></div>
        <div className="absolute bottom-1/3 right-1/12 w-20 h-px bg-gradient-to-l from-transparent via-copper-brown/8 to-transparent"></div>
        <div className="absolute top-1/2 left-1/10 w-12 h-px bg-gradient-to-r from-transparent via-soft-saffron/6 to-transparent transform rotate-45"></div>
      </div>

      {/* Subtle Texture Overlay */}
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23474e3b' fill-opacity='0.1'%3E%3Cpath d='M20,20m-1,0a1,1 0 1,1 2,0a1,1 0 1,1 -2,0'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: "40px 40px",
        }}
      ></div>

      {/* Gradient Overlay for Depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/5 to-misty-sage/8"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Content */}
            <div className="order-2 lg:order-1">
              <div className="mb-4 sm:mb-6">
                <div className="w-12 sm:w-16 h-1 bg-gradient-to-r from-soft-saffron to-copper-brown rounded-full"></div>
              </div>

              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-forest-green mb-4 sm:mb-6">
                Cittasya® — Wellness Begins With the Mind
              </h2>

              {/* Sanskrit Invocation */}
              <div className="bg-gradient-to-r from-soft-saffron/10 to-copper-brown/10 rounded-xl p-6 mb-6 border border-soft-saffron/20">
                <div className="text-center">
                  <div className="sanskrit text-lg sm:text-xl text-forest-green leading-relaxed ">
                    योगेन चित्तस्य पदेन वाचां
                    <br />
                    मलं शरीरस्य च वैद्यकेन ।<br />
                    योऽपाकरोत्तं प्रवरं मुनीनां
                    <br />
                    पतञ्जलिं प्राञ्जलिरानतोऽस्मि ॥
                  </div>
                  {/* <p className="text-sm text-copper-brown italic">
                    Timeless Sanskrit invocation honoring Sage Patañjali
                  </p> */}
                </div>
              </div>

              <div className="prose prose-lg max-w-none">
                <p className="text-lg sm:text-xl text-copper-brown leading-relaxed mb-6">
                  The brand Cittasya is inspired by this timeless Sanskrit
                  invocation honoring Sage Patanjali. It reminds us that through
                  yoga, the mind (<em>citta</em>) is refined and brought into
                  balance.
                </p>

                <p className="text-lg sm:text-xl text-copper-brown leading-relaxed mb-6">
                  In ancient philosophy, the <em>citta</em> or our inner
                  dimension, is often compared to a mirror. Just as a mirror
                  gathers dust and smudges, the mind too becomes clouded by{" "}
                  <em>vrttis</em> (thought-waves),
                  <em> samskaras</em> (impressions), and <em>vasanas</em> (latent
                  tendencies). When this mirror of mind is unclear, perception
                  is distorted and we see reality through conditioning and
                  projection, reacting habitually rather than consciously.
                </p>

                <p className="text-lg sm:text-xl text-copper-brown leading-relaxed mb-6">
                  Through <em>citta shuddhi</em> - purification of mind, the
                  inner mirror is polished clean and consciousness shines
                  unobstructed, restoring balance and harmony within. At
                  Cittasya®, we believe wellness begins with the mind. By
                  cultivating inner stillness and awareness, the modern mind can
                  move from restlessness to clarity, from stress to deep
                  relaxation - bringing emotional balance, sharper focus, deeper
                  creativity, and renewed vitality.
                </p>
              </div>

              {/* Mission Points */}
              <div className="space-y-3 sm:space-y-4">
                {[
                  "Ancient wisdom meets modern science",
                  "Accessible healing for everyone",
                  "Deep rest as medicine",
                  "Consciousness-based wellness",
                ].map((point, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full bg-soft-saffron"></div>
                    <span className="text-sm sm:text-base text-forest-green font-medium">
                      {point}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Visual Element */}
            <div className="order-1 lg:order-2 flex justify-center">
              <div className="relative w-full max-w-[320px] sm:max-w-[400px] mx-auto">
                {/* Main circle */}
          {/* Main circle */}
                <div className="aspect-square w-full rounded-full bg-gradient-to-br from-earth-ochre via-earth-orche to-forest-green animate-float shadow-2xl">
                  <div className="absolute inset-[10%] rounded-full bg-gradient-to-br from-cloud-white to-misty-sage flex items-center justify-center">
                    <div className="text-center">
                      <div className="sanskrit text-2xl sm:text-3xl md:text-4xl text-forest-green mb-1 sm:mb-2">
                        चित्त
                      </div>
                      <div className="text-xs sm:text-sm text-copper-brown font-medium">
                        Consciousness
                      </div>
                    </div>
                  </div>
                </div>

                {/* Orbiting elements */}
                <div className="absolute top-4 right-4 w-12 sm:w-16 h-12 sm:h-16 rounded-full bg-gradient-to-br from-amber-200 to-yellow-300 flex items-center justify-center shadow-lg animate-pulse">
                  <span className="text-xl sm:text-2xl">🕉️</span>
                </div>

                <div className="absolute bottom-8 left-4 w-8 sm:w-12 h-8 sm:h-12 rounded-full bg-gradient-to-br from-amber-200 to-yellow-100 flex items-center justify-center shadow-lg animate-pulse delay-1000">
                  <span className="text-base sm:text-lg">✨</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sankalpa Section - Bottom Center */}
        <div className="mt-16 sm:mt-20 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-misty-sage/20 to-sand-beige/20 rounded-2xl p-8 sm:p-12 border border-soft-saffron/30 backdrop-blur-sm shadow-lg">
              <h3 className="font-heading text-2xl sm:text-3xl font-bold text-forest-green mb-4 sm:mb-6">
                Reprogram Your Mind Using a Sankalpa
              </h3>
              <p className="text-lg sm:text-xl text-copper-brown leading-relaxed max-w-3xl mx-auto">
                A positive resolve or intention aligned with your values, higher
                purpose or transformative goals, becomes deeply embedded in the
                psyche when planted during Yoga Nidra. Create a short,
                meaningful Sankalpa and witness its power grow as your
                connection to it evolves over time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
